/**
 * Created by pmnia on 02/03/15.
 */
(function () {
    'use strict';
    angular
        .module('app.data')
        .factory('dataservice', dataService);

    /*@ngInject*/
    function dataService(queryservice, associationServices, clinicServices,
                         calendarServices, therapistServices,preferenceServices
                        ,bookingServices, loginServices, formServices
                    , dynamicServices, pageServices, advisorServices, oracleServices){
        return  {
            queryService : queryservice,
            association : associationServices,
            clinic : clinicServices,
            therapist : therapistServices,
            calendar : calendarServices,
            preference : preferenceServices,
            booking : bookingServices,
            login : loginServices,
            form : formServices,
            dynamic : dynamicServices,
            page : pageServices,
            advisor : advisorServices,
            oracle : oracleServices
        };
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/data/data.services.js
 ** module id = 165
 ** module chunks = 0
 **/